import { render, staticRenderFns } from "./RepairCauseIndex.vue?vue&type=template&id=03b8dcd7&scoped=true"
import script from "./RepairCauseIndex.vue?vue&type=script&lang=js"
export * from "./RepairCauseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8dcd7",
  null
  
)

export default component.exports